import { EmitterConfig, FloatPropConfig } from './emitterConfig'

export const CURRENT_EFFECT_VERSION = 4

export interface EffectConfig {
	version: number
	name: string
	emitters: EmitterConfig[]
}
